import { useMutation } from '@tanstack/react-query';
import { timeOffService } from '../api/time-off.service';

/** Triggers a browser download for an attachment. Requires `Full` visibility — `404` otherwise. */
export function useDownloadTimeOffAttachment() {
  return useMutation({
    mutationFn: async ({
      requestId,
      attachmentId,
      fileName,
    }: {
      requestId: string;
      attachmentId: string;
      fileName: string;
    }) => {
      const blob = await timeOffService.downloadAttachment(requestId, attachmentId);
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.click();
      URL.revokeObjectURL(url);
    },
  });
}
